var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extract"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-title"},[_vm._v("ENTREVISTADO")]),_vm._l((_vm.questions),function(header,index){return _c('div',{key:header.id,staticClass:"header-question"},[_vm._v(" "+_vm._s(index + 1)+". "+_vm._s(header.question)+" ")])})],2),_c('div',{staticClass:"body"})])
}
var staticRenderFns = []

export { render, staticRenderFns }